import * as _ from 'lodash';
import {
    CLEAR_STORE,
    FETCH_NOTIFICATION,
    FETCH_NOTIFICATION_SUCCESS,
    FETCH_NOTIFICATION_FAIL,
    NOTIFICATION_SEEN,
    ALL_NOTIFICATION_SEEN_SUCCESS,
    RECEIVE_GENERAL_NOTIFICATIONS,
    PAGINATE_NOTIFICATION,
    PAGINATE_NOTIFICATION_SUCCESS,
    FETCH_MY_PROFILE_SUCCESS
} from '../actions/types'

const INITIAL_STATE = {
    notificationCount: 0,
    notifications: {},
    isNotificationLoading: false,
    isPaginatingNotifications: false,
    page: 1,
    hasNextPage: false,
    isAllNotificationsSeen: true
};

const isNotificationExits = (state, notification) => {
    return state.notifications[notification._id] !== undefined;
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case FETCH_NOTIFICATION:
            return {
                ...state,
                notifications: {},
                isNotificationLoading: true,
                page: 1,
                hasNextPage: true
            };
        case FETCH_NOTIFICATION_SUCCESS:
            return {
                ...state,
                notifications: { ...state.notifications, ..._.keyBy(action.payload.notifications, '_id') },
                isNotificationLoading: false,
                hasNextPage: _.size(action.payload.notifications) > 0
            };
        case FETCH_NOTIFICATION_FAIL:
            return {
                ...state,
                isNotificationLoading: false,
                isPaginatingNotifications: false
            };
        case PAGINATE_NOTIFICATION:
            return {
                ...state,
                isPaginatingNotifications: true,
                page: action.payload.page
            };
        case PAGINATE_NOTIFICATION_SUCCESS:
            return {
                ...state,
                notifications: { ...state.notifications, ..._.keyBy(action.payload.notifications, '_id') },
                isPaginatingNotifications: false,
                hasNextPage: _.size(action.payload.notifications) > 0
            };
        case NOTIFICATION_SEEN:
            let notification = { ...state.notifications[action.payload.nid] };
            if (notification && !notification.isSeen) {
                notification.isSeen = true;
                return {
                    ...state,
                    notifications: { ...state.notifications, [action.payload.nid]: notification },
                    notificationCount: state.notificationCount - 1
                };
            } else {
                return {
                    ...state
                }
            }
        case ALL_NOTIFICATION_SEEN_SUCCESS:
            let notifications = { ...state.notifications };
            notifications = _.map(notifications, function (notification) { notification.isSeen = true; return notification });
            return {
                ...state,
                notifications: notifications,
                isAllNotificationsSeen: true,
                notificationCount: 0
            };
        case RECEIVE_GENERAL_NOTIFICATIONS:
            if (!isNotificationExits(state, action.payload.data)) {
                return {
                    ...state,
                    notifications: { [action.payload.data._id]: action.payload.data, ...state.notifications },
                    isAllNotificationsSeen: false,
                    notificationCount: state.notificationCount + 1
                };
            } else {
                return {
                    ...state
                }
            }
        case FETCH_MY_PROFILE_SUCCESS:
            return {
                ...state,
                notificationCount: _.get(action.payload, "notificationCount", 0)
            }
        case CLEAR_STORE:
            return INITIAL_STATE;
        default:
            return state
    }
}
